"use client";

// The production Homepage header is the single visual and interaction source of
// truth. All public, functional, checkout, and signed-in shells import through
// this stable path so route-specific pages cannot drift onto an older variant.
export { HomeHeader } from "@/components/skin-lab/current/home-header";
